import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { AddressValidationId, HtmlId, OverlayView, ProductType } from '../enum';
import { createPromotionalCard, PromotionalCard } from '@vfde-brix/ws10/promotional-card';
import { CmsPromotionalCard } from '../interface';
import promotionalCardUtil from '../util/component/promotionalCard.utils';
import { setOverlayVisibility } from '../container/App/action';
import { ProductContainerProps } from '../container/Product';

export const mountPromotionalCard = (id: HtmlId) =>
    createComponentById(createPromotionalCard, id, NO_PATTERN_BUSINESS_LOGIC);

export const updatePromotionalCard = (
    comp: PromotionalCard | null,
    stateProps: ProductContainerProps,
    cmsProps: CmsPromotionalCard,
) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    props.txtSublabel = promotionalCardUtil.getSubline(stateProps, cmsProps);

    comp.update(props);

    const isHidden = stateProps.selected.type !== ProductType.CABLE ||
        stateProps.isBookingDisabled ||
        stateProps.isNonMonthlyBilling ||
        stateProps.hasTvContract ||
        Boolean(
            !stateProps.hasTvConnect &&
            stateProps.availabilityResult &&
            !stateProps.tvConnect &&
            !stateProps.tvConnectBv
        );

    comp.toggleContainer(isHidden);
};

export const updatePromotionalCardLink = (showOverlay: typeof setOverlayVisibility) => {
    const link = document.getElementById(AddressValidationId.MORE_INFO_BUTTON);

    link?.addEventListener('click', () => showOverlay(OverlayView.MORE_INFO));
};
